import AuthReducer from './auth/AuthSlice'
import FacebookReducer from './customer-resources/facebook/FacebookSlice'

const rootReducer = {
  authReducer: AuthReducer,
  facebookReducer: FacebookReducer,
}

export default rootReducer
